import {observer} from "mobx-react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import React from "react";
import SelectSearchUser from "@dropDesk/presentation/components/inputs/select_search_users";
import {UserRole} from "@dropDesk/domain/entities/user/user_enum";
import {UserEntity} from "@dropDesk/domain/entities/user/user.entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {Tooltip} from "antd";

const InputAttendantSearch = observer(
    ({
         setFilterAttendant,
         filterAttendant,
         loading,
         hideLabel,
         size
     }: {
        setFilterAttendant: (filter: UserEntity | null, withList?: boolean) => void,
        filterAttendant: UserEntity | null
        loading: boolean,
        hideLabel?: boolean,
        size?: number
    }) => {

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        return (
            <>
                {!appController.isUserClient &&
                    <Tooltip title={hideLabel ? 'Filtrar por atendente' : undefined}>
                        <div style={{display: "flex", flex: 1}}>
                            <SelectSearchUser
                                size={size ?? 40}
                                useRemoveFilter={!!filterAttendant}
                                label={hideLabel ? undefined : 'Filtrar por atendente'}
                                placeHolder={"Pesquise por atendente"}
                                handleSelectUser={(value, user) => {
                                    setFilterAttendant(user ?? null);
                                }}
                                value={filterAttendant ? {
                                    value: filterAttendant.id,
                                    label: filterAttendant.name
                                } : undefined}

                                role={UserRole.attendant}
                                disabled={loading}
                                iconLeftName={ICONS_DROPDESK.operator}
                                borderColor={filterAttendant ? colors.accent : colors.border}
                            />
                        </div>
                    </Tooltip>
                }
            </>
        )
    })
export default InputAttendantSearch;
